export enum AsyncActionErrors {
  UnrecognizedError = 0,
  
  NoPermissions = 1,
  
  TargetCollectionWasNotFound = 2,
  
  QuestionsWereNotFound = 3,
  
  CandidatesFilterWasNotSet = 4,
  
  ScheduleWasNotFound = 5,
  
  CannotRemoveAllCandidates = 6,
  
  OverHardLimit = 7
}
